import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { CustomerNotesBody } from '../../../CustomerNotes'
import './customerNotesDashboard.sass'

interface CustomerNotesDashboardProps {
    title: string
    allRowData: CustomerModelType
    getData: () => Promise<void>
}

const CustomerNotesDashboard: React.FC<CustomerNotesDashboardProps> = ({ allRowData, title, getData }) => {
    const { t } = useTwinTranslation()
    const userPermissions = getUserPermissions('customer.profile.notes')
    return (
        <div className='flex flex-col flex-auto gap-15 overflow-auto customer_notes_dashboard'>
            <div className='flex items-center gap-x-10 pb-5 border-b border-gray-EE'>
                <h3>{title}</h3>
                <CustomerDashboardSeeAllLink customerTab='notes' customerType={allRowData?.customer_type} text={t('seeAllNotes', 'Ver todas las notas')} className='ml-auto' />
            </div>
            <div className='flex flex-col flex-auto'>
                <CustomerNotesBody userPermissions={userPermissions || { n: 4, permission: 'delete' }} basicData={allRowData} getData={getData} />
            </div>
        </div>
    )
}

export default CustomerNotesDashboard